import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import GettingStartedGuide from './GettingStartedGuide';
import { HELP_BUTTON_STORAGE_KEY } from './FloatingHelpButton';

const HelpPage = () => {
  const navigate = useNavigate();
  const [showHelpButton, setShowHelpButton] = useState(() => {
    const saved = localStorage.getItem(HELP_BUTTON_STORAGE_KEY);
    return saved === null ? true : saved === 'true';
  });

  const toggleHelpButton = () => {
    const newValue = !showHelpButton;
    setShowHelpButton(newValue);
    localStorage.setItem(HELP_BUTTON_STORAGE_KEY, newValue.toString());
  };

  return (
    <main className="p-4 min-h-screen">
      <div className="max-w-4xl mx-auto">
        <div className="mb-6 flex items-center justify-between">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
          >
            <ArrowLeftIcon className="w-5 h-5" />
            <span>Back</span>
          </button>

          <button
            onClick={toggleHelpButton}
            className="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
          >
            {showHelpButton ? (
              <>
                <EyeSlashIcon className="w-4 h-4" />
                <span>Hide Help Button</span>
              </>
            ) : (
              <>
                <EyeIcon className="w-4 h-4" />
                <span>Show Help Button</span>
              </>
            )}
          </button>
        </div>

        <GettingStartedGuide />

        <div className="mt-6 bg-gray-50 rounded-lg p-4 text-sm text-gray-600">
          <p>
            <strong>Tip:</strong> The floating help button in the bottom-right corner provides quick access to this guide from any page.
            {showHelpButton
              ? ' Click "Hide Help Button" above to hide it if you no longer need it.'
              : ' Click "Show Help Button" above to show it again.'}
          </p>
        </div>
      </div>
    </main>
  );
};

export default HelpPage;
